import {
    onCLS,
    onFID,
    onLCP,
    onINP,
    Metric,
} from 'web-vitals';
import AbstractTrackingService from '@ve/services/analytics/yandexAnalytics/abstractTrackingService';
import trackingService from './tracking';

const HIGH_INP_THRESHOLD_MS = 300;
const HIGH_INP_GOAL_LIMIT_PER_PAGE = 10;

const { coreWebVitals } = trackingService;
const coreWebVitalsTrack = coreWebVitals.bind(trackingService);
const trackProxy = (options: Metric) => coreWebVitalsTrack(options);

const yandexTrackingService = new AbstractTrackingService();
let highInpGoalCount = 0;

const trackHighInp = ({ value }: Metric) => {
    if (value <= HIGH_INP_THRESHOLD_MS) {
        return;
    }

    if (highInpGoalCount >= HIGH_INP_GOAL_LIMIT_PER_PAGE) {
        return;
    }

    highInpGoalCount += 1;
    yandexTrackingService.trackHighInp(value);
};

onCLS(trackProxy);
onFID(trackProxy);
onLCP(trackProxy);
onINP(trackProxy);
onINP(trackHighInp, { reportAllChanges: true });
